import { StateToken } from '@ngxs/store';
import { AuthStateRootModel } from '../models';

export interface AuthStateModel extends AuthStateRootModel { }

export const AUTH_STATE_TOKEN = new StateToken<AuthStateModel>('auth');
